import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';
import CaseInfoTab from './CaseInfoTab';
import CaseParticipantsTab from './CaseParticipantsTab';
import DocumentAssignmentSection from './DocumentAssignmentSection';
import { useEFiling } from '../contexts/EFilingContext';

interface CaseDetailsTabProps {
  brand: BrandConfig;
}

const CaseDetailsTab: React.FC<CaseDetailsTabProps> = ({ brand }) => {
  const { ocrPopulatedFields } = useEFiling();
  return (
    <div>
      <CaseInfoTab brand={brand} ocrPopulatedFields={ocrPopulatedFields} />
      <hr className="my-6" style={{ borderColor: brand.colors.border }} />
      <CaseParticipantsTab brand={brand} />
      {/* Per-document On Behalf Of / Filing Attorney, right after the
          participants they reference are created (Walter 2026-07-10 R20) —
          no walk back to Upload Documents. */}
      <DocumentAssignmentSection brand={brand} />
    </div>
  );
};

export default CaseDetailsTab;
